<template>
  <component :is="layoutName">
    <router-view />
    <v-snackbar v-model="messageShown" multi-line>
      {{ message }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="messageShown = false"
          >Закрити</v-btn
        >
      </template>
    </v-snackbar>
  </component>
</template>

<script>
import LoadingLayout from "@/layouts/LoadingLayout";
import DefaultLayout from "@/layouts/DefaultLayout";
import AuthLayout from "@/layouts/AuthLayout";

export default {
  name: "App",
  components: {
    LoadingLayout,
    DefaultLayout,
    AuthLayout,
  },
  computed: {
    layoutName() {
      return this.$route.meta.layout
        ? `${this.$route.meta.layout}-layout`
        : "loading-layout";
    },
    message() {
      return this.$store.state.message;
    },
    messageShown: {
      get() {
        return this.$store.state.messageShown;
      },
      set(newValue) {
        this.$store.commit("SET_MESSAGE_SHOWN", newValue);
      },
    },
  },
  watch: {
    messageShown(newValue) {
      if (newValue === false) {
        this.$store.commit("SET_MESSAGE", null);
      }
    },
  },
};
</script>
